var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgSoonGridDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 676,
    height: 391,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#8492C4",
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(1.22477 -.70707)rotate(45 339.057 -135.256)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(-1.22477 .70707)rotate(-45 521.927 611.453)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(1.22477 -.70707)rotate(45 371.832 -121.68)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(-1.22477 .70707)rotate(-45 489.15 625.028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.953 224.93 389.786 29.897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(-1.22477 .70707)rotate(-45 456.377 638.605)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(1.22477 -.70707)rotate(45 437.382 -94.529)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(-1.22477 .70707)rotate(-45 423.601 652.18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(1.22477 -.70707)rotate(45 470.156 -80.953)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(-1.22477 .70707)rotate(-45 390.826 665.755)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(1.22477 -.70707)rotate(45 502.931 -67.377)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(-1.22477 .70707)rotate(-45 358.053 679.333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(1.22477 -.70707)rotate(45 535.705 -53.8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(-1.22477 .70707)rotate(-45 325.277 692.907)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(1.22477 -.70707)rotate(45 568.483 -40.226)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(-1.22477 .70707)rotate(-45 292.5 706.483)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(1.22477 -.70707)rotate(45 601.247 -26.657)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(-1.22477 .70707)rotate(-45 259.727 720.06)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(1.22477 -.70707)rotate(45 634.023 -13.082)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(-1.22477 .70707)rotate(-45 226.952 733.635)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(1.22477 -.70707)rotate(45 666.796 .495)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(-1.22477 .70707)rotate(-45 194.177 747.211)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.231 346.905 337.833-195.034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(-1.22477 .70707)rotate(-45 161.403 760.786)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(1.22477 -.70707)rotate(45 732.347 27.645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(-1.22477 .70707)rotate(-45 128.628 774.362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(1.22477 -.70707)rotate(45 765.12 41.222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(-1.22477 .70707)rotate(-45 95.853 787.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(1.22477 -.70707)rotate(45 797.897 54.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-.5h390.089",
    transform: "scale(-1.22477 .70707)rotate(-45 63.078 801.514)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSoonGridDark);
export default __webpack_public_path__ + "static/media/img-soon-grid-dark.e6c086c2a401464e156f6ba2f32144d0.svg";
export { ForwardRef as ReactComponent };